import useCollection from "./useCollection"

import { mutate } from "swr"
import API from "./api"

export default function useFormSectionFields(sectionId) {
  const key = `/form_sections/${sectionId}/fields`

  const fields = useCollection({ key })

  async function reorder(from, to) {
    await API.post(`/form_sections/${sectionId}/reorder_fields`, { from, to })
    mutate(key)
  }

  fields.reorder = reorder

  return fields
}
